import { getEnuData } from '@/api/common'
import { getModelById, saveModel, checkExist } from '@/api/common'
import { formatDate, formatDate1, checkMobile, checkMail, checkDouble } from './util'

export default {
    props: {
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        id: {
            type: Number,
            default() {
                return -1;
            }
        },
        title: {
            type: String,
            default() {
                return ""
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        }
    },
    data() {
        return {
            showflag: false,
            old_check: '',
            exits_p_name: '',
            exits_p_title: '',
            init_model: '',
            form_name: 'formValidate',
            enu_obj: {},
            enu_name: []
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            if (newv) {
                this.resetModel(this.form_name);
                this.loadData();
            }
        }
    },
    mounted() {
        this.init_model = this.copyObj(this.model);
    },
    methods: {
        loadOtherData() {
            //加载其他内容，可重写
        },
        async loadData() {
            this.loadOtherData();
            if (this.enu_name.length > 0) {
                await this.initEnuData();     //初始化枚举
            }
            this.getModelData()         //获取数据
        },
        initEnuData() {
            return new Promise((resolve) => {
                getEnuData(this.enu_name).then(res => {
                    if (res.code == 1) {
                        let enu_array = res.data
                        for (let i = 0; i < enu_array.length; i++) {
                            let e_obj = enu_array[i];
                            let vals = e_obj.values;
                            let diss = e_obj.displays;
                            let e_Map_Obj = {};
                            let e_Map_Obj1 = [];
                            for (let j = 0; j < (vals.length < diss.length ? vals.length : diss.length); j++) {
                                e_Map_Obj[vals[j]] = diss[j]
                                e_Map_Obj1[j] = vals[j] + ',' + diss[j]
                            }
                            this.enu_obj[e_obj.name] = e_Map_Obj;
                            this.enu_obj[e_obj.name + 'order_data'] = e_Map_Obj1;
                        }
                        resolve();
                        return
                    }
                })
            })
        },
        getModelData() {
            this.model = this.copyObj(this.init_model);
            if (this.id > 0) {
                this.getObj.data.value = this.id;
                getModelById(this.getObj).then(res => {
                    if (res.code === 1) {
                        this.model = res.data;
                        if (this.exits_p_name != '') {
                            this.old_check = this.model[this.exits_p_name];
                        }
                        this.formateData();
                    } else {
                        this.$msg(res.msg)
                        this.closeDialog()
                    }
                })
            }
        },
        validExist(rule, value, callback) {
            if (value.trim() != '') {
                let check = true;
                if (this.id > 0) {
                    if (this.model[this.exits_p_name].trim() === this.old_check.trim()) {
                        check = false;
                    }
                }
                if (check) {
                    this.checkObj.data[this.exits_p_name] = this.model[this.exits_p_name].trim();
                    checkExist(this.checkObj).then(res => {
                        if (res.code === 1) {
                            callback();
                        } else {
                            callback(new Error(this.exits_p_title + "重复"));
                        }
                    }).catch();
                } else {
                    callback();
                }
            }
        },
        formatModel() {
            for (let key in this.model) {
                let val = this.model[key]
                if (this.$isNull(val)) {
                    delete this.model[key];
                }
            }
        },
        formateData() {
            //加载完数据后，需要格式化的数据在这里处理 可重写
        },
        //重置表单
        resetModel(name) {
            if (this.$refs[name] !== undefined) {
                this.$refs[name].resetFields();
            }
        },
        copyObj(source) {
            if (!source) {
                return null;
            }
            return JSON.parse(JSON.stringify(source));
        },
        transEnu(val, enum_name) {
            let enuInfo = this.enu_obj[enum_name];
            if (enuInfo != undefined) {
                let dis = enuInfo[val];
                return dis;
            } else {
                return val;
            }
        },
        enuObj(enum_name) {
            let enuInfo = this.enu_obj[enum_name + 'order_data'];
            let arr = [];
            if (enuInfo != undefined) {
                var values = Object.values(enuInfo);
                for (let i = 0; i < values.length; i++) {
                    let str = values[i].split(",")
                    let temp = {};
                    temp["key"] = str[0]
                    temp["title"] = str[1]
                    arr.push(temp)
                }
            }
            return arr
        },
        toLocaleString(data) {
            // 按自定义拼接格式返回
            return data.getFullYear() + "-" + this.addZero(data.getMonth() + 1) + "-" + this.addZero(data.getDate()) + " " +
                this.addZero(data.getHours()) + ":" + this.addZero(data.getMinutes()) + ":" + this.addZero(data.getSeconds());
        },
        addZero(num) {
            if (num < 10)
                return "0" + num;
            return num;
        },
        closeDialog() {
            this.$emit("on-close")
        },
        formatDate(date, fmt) {
            return formatDate(date, fmt)
        },
        formatDate1(date, fmt) {
            return formatDate1(date, fmt)
        },
        validDouble(rule, value, callback) {
            value = value+"";
            if (this.$isNotNull(value)) {
                if (!checkDouble(value)) {
                    callback(new Error("数值格式错误"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validMobile(rule, value, callback) {
            value = value+"";
            if (this.$isNotNull(value)) {
                if (!checkMobile(value)) {
                    callback(new Error("手机号码格式错误"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validMail(rule, value, callback) {
            if (value.trim() != '') {
                if (!checkMail(value)) {
                    callback(new Error("邮箱格式错误"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },        
        removeEmptyChild(data){
            data.forEach(v => {
                if (v.children.length==0) {
                    v.children = null
                }else{
                    this.removeEmptyChild(v.children)
                }
            })
            return data
        },
    },
}